export enum Components {
    shakaPlayer = 'Shaka Player',
    webPlayer = 'WebPlayer',
}
